var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from './label.js';
import { HelperText } from './helper-text.js';
import { forwardRef } from 'react';
/**
 * Combines `Label` and `HelperText` in a standard use-case
 */
export const InputWrapper = forwardRef((_a, forwardedRef) => {
    var { errorText, helperText, children } = _a, props = __rest(_a, ["errorText", "helperText", "children"]);
    return (_jsxs(Label, Object.assign({ ref: forwardedRef }, props, { children: [children, (helperText || errorText) && _jsx(HelperText, { helperText: helperText, errorText: errorText })] })));
});
//# sourceMappingURL=input-wrapper.js.map